<template>
    <div class="fixed">
        <slot name="default"></slot>
    </div>
</template>

<script lang="ts" setup>
import { useHideBodyOverflow } from '@/composables/useHideBodyOverflow'
import { useEmitCloseOnEscapeKey } from '@/composables/ui/useEmitCloseOnEscapeKey'

const emit = defineEmits<{
    close: []
}>()

useHideBodyOverflow()
useEmitCloseOnEscapeKey(emit)
</script>

<style lang="scss" scoped>
.fixed {
    @include fixed;

    z-index: 200;
}
</style>
